<template>
    
    <div>
        <vs-row class="cardGeneral">
            <vs-col class="cardReportes" vs-type="flex" vs-justify="center" vs-align="center" w="12">
                <vs-row>
                    <vs-col sm="12" lg="8">
                        <h4 class="p-2">Promociones</h4>
                    </vs-col>
                    <vs-col sm="6" lg="4">
                         <vs-button
                            success
                            class="ml-auto"
                            @click="activeCrear =! activeCrear"
                        >
                            Crear Registro
                        </vs-button>
                    </vs-col>
                </vs-row>
                <vs-row class="mt-4">
                    <vs-col sm="12" lg="3">
                        <form autocomplete="off">
                            <label for="institucion" class="labelInput">
                                Institución
                            </label>
                            <vs-select filter class="aqui pt-0" id="institucion" placeholder="Seleccionar Institución" :key="institucionId" v-model="institucion" v-if="instituciones.length" :disabled="!instituciones.length" autocomplete="off" >
                                <template #message-danger v-if="errorFields.includes('institucion')">
                                    Requerido
                                </template>
                                <template v-if="instituciones.length" autocomplete="off">
                                    <vs-option v-for="option in instituciones" :key="option.id"  :label="option.text" :value="option.id">
                                        {{option.text}}
                                    </vs-option>
                                </template>
                                <template v-else>
                                    <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                                    </vs-option>
                                </template>
                            </vs-select>
                        </form>
                    </vs-col>
                    <vs-col sm="12" lg="3">
                        <form autocomplete="off">
                            <label for="cicloEscolar" class="labelInput">
                                Ciclo Escolar
                            </label>
                            <vs-select filter :loading="loadingSelect" class="aqui pt-0" id="cicloEscolar" placeholder="Seleccionar Ciclo Escolar" :key="cicloId" v-model="cicloEscolar" v-if="instituciones.length" :disabled="!ciclosEscolares.length" autocomplete="off">
                                <template #message-danger v-if="errorFields.includes('cicloEscolar')">
                                    Requerido
                                </template>
                                <template v-if="ciclosEscolares.length" autocomplete="off">
                                    <vs-option v-for="option in ciclosEscolares" :key="option.id"  :label="option.text" :value="option.id">
                                        {{option.text}}
                                    </vs-option>
                                </template>
                                <template v-else>
                                    <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                                    </vs-option>
                                </template>
                            </vs-select>
                        </form>
                    </vs-col>
                    <vs-col sm="12" lg="3">
                        <form autocomplete="off">
                            <label for="programa" class="labelInput">
                                Programa
                            </label>
                            <vs-select filter :loading="loadingSelect" class="aqui pt-0" id="programa" placeholder="Seleccionar Programa" :key="programaId" v-model="programa" :disabled="!programas.length || nivel != ''">
                                <template #message-danger v-if="errorFields.includes('programa')">
                                    Requerido
                                </template>
                                <template v-if="programas.length">
                                    <vs-option v-for="option in programas" :key="option.id"  :label="option.text" :value="option.id">
                                        {{option.text}}
                                    </vs-option>
                                </template>
                            </vs-select>
                            <div v-if="programa !== ''" @click="programa = ''" class="tache">
                                <i class="far fa-times-circle"></i>
                            </div>
                        </form>
                    </vs-col>
                    <vs-col sm="12" lg="3">
                        <form autocomplete="off">
                            <label for="nivel" class="labelInput">
                                Nivel Académico
                            </label>
                            <vs-select filter :loading="loadingSelect" class="aqui pt-0" id="nivel" placeholder="Seleccionar Nivel Académico" :key="nivelId" v-model="nivel" :disabled="!niveles.length || programa != ''">
                                    <vs-option v-for="option in niveles" :key="option.id"  :label="option.text" :value="option.id">
                                        {{option.text}}
                                    </vs-option>
                            </vs-select>
                            <div v-if="nivel !== ''" @click="nivel = ''" class="tache">
                                <i class="far fa-times-circle"></i>
                            </div>
                        </form>
                    </vs-col>
                    <vs-col sm="12" lg="3">
                        <label for="grupo" class="labelInput">
                            Filtro
                        </label>
                            <vs-input class="pt-0" v-model="filtro" placeholder="Filtro">
                            </vs-input>
                            <div v-if="tache" @click="deseleccionar('filtro')" class="tache">
                                <i class="far fa-times-circle"></i>
                            </div>
                    </vs-col>
                    <vs-col sm="12" lg="12">
                        <vs-button
                            class="ml-auto"
                            @click="getInfoPromociones()"
                        >
                            <i class="fas fa-search mr-2"></i>Buscar
                        </vs-button>
                    </vs-col>
                </vs-row>

                <!-- <tabla-promociones :users="regs" :institucion="institucion" :cicloEscolar="cicloEscolar" :institucionesArray="instituciones" :ciclosEscolaresArray="ciclosEscolares"></tabla-promociones>  -->
                <tabla-promociones :regs="regs" :institucion="institucion" :cicloEscolar="cicloEscolar" :institucionesArray="instituciones" :ciclosEscolaresArray="ciclosEscolares" @refreshTable="getInfoPromociones" :filter="filtro"></tabla-promociones>

                <crear v-model="activeCrear" :institucionSelect="institucion" :cicloSelect="cicloEscolar" :institucionesArray="instituciones" :ciclosEscolaresArray="ciclosEscolares" @refreshTable="getInfoPromocionesRefresh"></crear>

            </vs-col>
        </vs-row>
    </div>
</template>
<script>
import academico from '../../../api/requests/academico'
import PromocionesTable from './PromocionesTable.vue'
import TablaPromociones from './tabla-promociones.vue'
import crear from './modal/crear.vue'
export default {
    data(){
        return{
            institucion: '',
            instituciones: [],
            institucionId: (new Date()).getTime(),
            cicloEscolar: '',
            ciclosEscolares: [],
            cicloId: (new Date()).getTime(),
            programa: '',
            programas: [],
            programaId: (new Date()).getTime(),
            loadingPrograma: false,
            nivel: '',
            niveles: [],
            nivelId: (new Date()).getTime(),
            errorFields: [],
            users: [],
            filtro: '',
            regs: [],
            tache: false,
            activeCrear: false,
            loadingSelect: false
        }
    },
    components:{
        PromocionesTable,
        TablaPromociones,
        crear
    },
    created(){
        this.getInstituciones()
    },
    methods:{
        async getInstituciones(){
            try {
                const response = await academico.getInstitucion()
                this.instituciones = response.data
            }
            catch{
                
            }
        },
        async getCicloEscolar() {
            this.loadingSelect = true
            const { data: response } = await academico.getCiclosEscolares(this.institucion)
            this.ciclosEscolares = response
            this.cicloId = (new Date()).getTime()
            this.loadingSelect = false
        },
        async getPrograma(){
            if (this.institucion) {
                try {
                    this.loadingPrograma = true
                    const {data: response} = await academico.getPrograma(this.institucion)
                    this.programas = response
                    this.programaId = (new Date()).getTime()
                    this.loadingPrograma = false
                } catch (error) {
                    
                }
            }
        },
        async getNivelAcademico() {
            if(this.institucion){
                this.nivel = ''
                this.loadingSelect = true
                const params = {
                    "institucion_id": this.institucion
                }
                const { data: response } = await academico.getNivelAcademico(params)
                this.niveles = response
                this.nivelId = (new Date()).getTime()
                this.loadingSelect = false
            }
        },
        checkByType (type, val) {
            switch (type) {
                case 'string':
                    if (val && val.constructor.name === 'String' && val.trim()) {
                        return true
                    }
                case 'number':
                    if (val && val.constructor.name === 'Number' && val > 0) {
                        return true
                    } 
                case 'array':
                    if (Array.isArray(val) && val.length){
                        return true
                    }
            }
            return false
        },
        sanityForm () {
            this.errorFields = []
            if (!this.checkByType ('number', this.cicloEscolar)) {
                this.errorFields.push('cicloEscolar')
            }
            if (!this.checkByType ('number', parseInt(this.institucion))) {
                this.errorFields.push('institucion')
            }
            if (!this.errorFields.length){
                const params = {
                    page: '1',
                    ciclo_escolar_id: this.cicloEscolar,
                    // filtro: this.filtro,
                    institucion_id: this.institucion
                }
                if(this.programa != ''){
                    params.programa_id = this.programa
                }else if(this.nivel != ''){
                    params.nivel_academico_id = this.nivel
                }
                return params
            } else {
                return null
            }
        },
        async getInfoPromociones(){
            const info = this.sanityForm()
            if(info){
                try {
                    const loading = this.$vs.loading()
                    const { data: response } = await academico.getInfoPromociones(info)
                    this.regs = response.data
                    loading.close()
                }
                catch{
                    loading.close()
                }
            }
        },
        async getInfoPromocionesRefresh(institucion, ciclo){
            try {
                const loading = this.$vs.loading()
                const params = {
                    page: '1',
                    institucion_id: institucion,
                    ciclo_escolar_id: ciclo
                }
                const { data: response } = await academico.getInfoPromociones(params)
                this.regs = response.data
                this.institucion = institucion
                this.cicloEscolar = ciclo
                loading.close()
            }
            catch{
                loading.close()
            }
        },
        deseleccionar(type) {
            if(type === 'filtro'){
                this.filtro = ''
            }
        },
    },
    watch:{
        institucion(){
            this.getCicloEscolar()
            this.getPrograma()
            this.getNivelAcademico()
        },
    }
}
</script>

<style lang="scss" scoped>
    .cardReportes{
        width: 100%;
        background-color:white;
        justify-content: space-between;
        @media only screen and (max-width: 768px) {
            margin: 16px;
        }
        @media only screen and (min-width: 768px) {
            margin: 16px 15px;
        }
        border-radius: 3px;
        padding: 10px
    }
    .cardGeneral{
        @media only screen and (max-width: 768px) {
            width: 85%;
        }
        @media only screen and (min-width: 768px) {
            width: 100%;
        }
    }
    .tache{
        position: absolute;
        cursor: pointer;
        top: 35px;
        @media only screen and (max-width: 768px) {
            left: calc(95% - 4em);
        }
        @media only screen and (min-width: 768px) {
            left: calc(98% - 4em);
        }

    }
</style>